export default "__VITE_ASSET__70c69219__"